{
  "el": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Δημοσιευμένο για πελάτες και συνεργάτες",
        "publishedCustomer": "Δημοσιευμένο για πελάτες",
        "publishedPartners": "Δημοσιευμένο για συνεργάτες",
        "notPublished": "Μη δημοσιευμένο"
      },
      "publish_mode": {
        "inherit": "Ακολούθηση προτύπου",
        "inherit_info": "Διατηρεί την κατάσταση δημοσίευσης κάθε στοιχείου από το πρότυπο",
        "publish": "Δημοσίευση στους πελάτες",
        "publish_info": "Οι πελάτες μπορούν να τα δουν αμέσως",
        "title": "Δημοσίευση",
        "unpublished": "Δημιουργία χωρίς δημοσίευση",
        "unpublished_info": "Κρυφά από τους πελάτες μέχρι να τα δημοσιεύσεις"
      }
    }
  }
}
